<template>
  <div class="product-labels" :class="{ 'product-labels--relative': relative }">
    <template v-for="(label, index) in labels">
      <ProductLabel
        v-if="label.code !== 'SALES' && label.code !== 'YOU_MAY_LIKE'"
        :key="`label-${index}`"
        :label="label"
        :small="small"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import type { Condition, OfferCatalogDelivery } from '~/types/offer'
import type { ProductCategory, ProductLabel as ProductLabelType } from '~/types/product'


type Props = {
  label: ProductLabelType | null
  offerLabel: ProductLabelType | null
  condition: Condition | null
  category: ProductCategory
  delivery: OfferCatalogDelivery | null
  discount: number
  relative?: boolean
  small?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  relative: false,
  small: false
})

const conditionLabel = computed(() => {
  if (props.condition) {
    return getConditionLabel({
      category: props.category,
      condition: props.condition
    })
  } else {
    return null
  }
})

const labels = computed((): ProductLabelType[] => {
  const labelsArray = props.label
    ? [props.label, props.offerLabel || conditionLabel.value]
    : [props.offerLabel, conditionLabel.value]
  const labelsFiltered = labelsArray.filter((item) => !!item) as ProductLabelType[]

  return labelsFiltered
})

</script>

<style lang="scss" scoped>
.product-labels {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  pointer-events: none;

  &--relative {
    position: relative;
    flex-direction: row;
    gap: 4px;
  }
}
</style>
